import {
  getServiceOrderTypeValuesByLabel,
  getServiceOrderTypeValuesByType,
  ServiceOrderType,
} from "@/_constants/serviceOrder.ts";

import ColoredMarker from "./ColoredMarker";


type ServiceStatusComponentProps = {
  type?: ServiceOrderType;
  label?: string;
};

const ServiceTypeMinComponent = ({
  type,
  label = "",
}: ServiceStatusComponentProps) => {
  const values =
    getServiceOrderTypeValuesByType(type as ServiceOrderType) ||
    getServiceOrderTypeValuesByLabel(label);
  return <ColoredMarker color="#000D5B">{values?.labelMin}</ColoredMarker>;
};

export default ServiceTypeMinComponent;
